export type DownloadedFile = {
  blob: Blob;
  filename: string;
};

export function filenameFromContentDisposition(header: string | null): string | undefined {
  if (!header) return undefined;

  const match = /filename\*=UTF-8''([^;]+)|filename="([^"]+)"|filename=([^;]+)/i.exec(header);
  const raw = match?.[1] ?? match?.[2] ?? match?.[3];
  if (!raw) return undefined;

  try {
    return decodeURIComponent(raw.trim());
  } catch {
    return raw.trim();
  }
}

export function triggerFileDownload({ blob, filename }: DownloadedFile): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
